var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-add"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6488",
    "data-name": "Rectangle 6488",
    width: 49,
    height: 49,
    fill: "#d7b16d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239619",
    "data-name": "Path 239619",
    d: "M26.208,8.083H24.167V6.042a2.042,2.042,0,0,0-4.083,0V8.083H18.042a2.042,2.042,0,1,0,0,4.083h2.042v2.042a2.042,2.042,0,1,0,4.083,0V12.167h2.042a2.042,2.042,0,1,0,0-4.083Z",
    transform: "translate(16.667 4.167)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239620",
    "data-name": "Path 239620",
    d: "M14.167,19.333A8.167,8.167,0,1,0,6,11.167a8.167,8.167,0,0,0,8.167,8.167Zm0-12.25a4.083,4.083,0,1,1-4.083,4.083A4.083,4.083,0,0,1,14.167,7.083Z",
    transform: "translate(6.25 3.125)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239621",
    "data-name": "Path 239621",
    d: "M17.292,13A14.292,14.292,0,0,0,3,27.292a2.042,2.042,0,0,0,4.083,0,10.208,10.208,0,1,1,20.417,0,2.042,2.042,0,0,0,4.083,0A14.292,14.292,0,0,0,17.292,13Z",
    transform: "translate(3.125 13.542)",
    fill: "#d7b16d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.f714b111d986cfc45235bae8ae642004.svg";
export { ForwardRef as ReactComponent };